import PL_utils from './patterns/pl-utils.js';

const body = document.querySelector('body');

export default () => {
    document.addEventListener('modalBeforeOpen', (e) => {
        const zoomLevel = 400;
        const targetModal = e.detail.component.getAttribute('data-target');
        PL_utils.addClass('modal-open', body);
        PL_utils.addClass('modal-open--' + targetModal, body);
        if(PL_utils.desktopIsZoomed(zoomLevel)) {
            PL_utils.addClass('zoomed', body);
        }
    });

    document.addEventListener('modalBeforeClose', (e) => {
        const targetModal = e.detail.component.getAttribute('data-target');
        PL_utils.removeClass('modal-open', body);
        PL_utils.removeClass('modal-open--' + targetModal, body);
        //check if is cookie modal, focus back to the top of the page
        if (targetModal === 'cookie-disclaimer-modal') {
            document.querySelector('body').focus();
        }
    });
};
